export default __webpack_public_path__ + "static/media/csv-icon.37dff962.png";